import { css } from '@emotion/react';
import { Theme } from '../../../config/theme';

export default (theme: Theme) => ({
  button: css`
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    text-align: left;
    background-color: ${theme.color.primary};
    color: ${theme.color.secondary};
    border: 1px solid ${theme.color.border};
    padding: ${theme.spacing.large};
    padding-bottom: 0;
    margin-bottom: ${theme.spacing.large};
    &:hover {
      background-color: ${theme.color.darkPrimary};
    }
    &:disabled {
      cursor: not-allowed;
      opacity: 50% !important;
    }
  `,
  selectedIndicator: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 1rem;
    height: 100%;
    background-color: ${theme.color.secondary};
  `,
  description: css`
    max-width: 70%;
  `,
});
